import { createContext } from "react";

export const UserContext = createContext(null)

export const OrderContext = createContext(null)

export const LoadFacePartsContext = createContext(null)

export const AdminStateContext = createContext(null)